import jsSHA from "jssha";

/**
 * This file is copied from scripts/hash_list.txt
 */
export const HASH_DATA = [
  "c32b9ea1b3191985a8ba8ae0b532ca8e6a66a92fb08d4d6d76071ad979b6af1a",
  "28fdc684326c862fa762acdbd85acc09b801a91424e336a3a21fe17c94e5f95e",
  "0edfdd71c186c1128e0ed128de51504c1a31a03739c48722c1a94db538fab12a",
  "172333f442f8d19eed4200327031282ec31c8d023df2f3a23711be3ef261b299",
  "f30bd3ddd7590a6ef51401557ecc7313c28af3951752847dbbb2407a75c30771",
  "238138ab56c18811c0904a6ee7c5b60ae5926c287332147cfb1320222d17f27a",
  "3f25b585c402dcf00bd5d2729bd0cabab6430af87d90d062bccad01f71760cec",
  "533701c1876ae16c524c809feb4a6f2ae4bcd471ccd39ceaf5ea887722795c08",
  "b62b36f838c4bf26f0a0d8c93bc26bda5ce3da83833fb2587fa592e021a4de82",
  "ddfe348c6ee1b83143e8332522fbe4feba826421828b0f7bda4e5b2afb097be8",
  "fd2ca727413ef918e2ae51d8cd90b144e185be9f0629811f2c2b62c52c2bbe23",
  "a676ab3dc2cdab02d10e820325d21994c55fcbfa440c233d742e04970af3c08b",
  "33672ad04ebe6f3e95cdf555143981511e88119050c86b5a204e61d9df5774a7",
  "348df0e1cb6396806c051d659e52b883afedf62ccfd4f460f4c14d85542d1527",
  "72297277325a78f7be88fd753699bc53a203a2cabbd85dd857ba773fac555261",
  "fdf23fb0c04565a9ff0b9ed50954d130b91fc7cdfc684779303dbe29b0fbc09b",
  "0170e5e2eec8b55a074a7b26e5a4f4b25ebac6ed40a798209774fd4ea9794948",
  "cef8754f89b59a8071fb8d80c41de0cca5acfe7815490e9bb749f130f2ee17fe",
  "c161854ace76e08bd41107b90b568917b34f553441faf43f3de555c330e46a71",
  "e6b0518b563f0dece39ad8462a6a0a4b90f57e384af923b3f0162c67f6a55144",
  "7085b83b584c71d05d941a4d0e36f77be17da94cff7d745c67eeb1dcd61e7f52",
  "8d9eae3b40983bc5f0d0f481a10fba1cc20a7116265bf81a76044372fea4bbad",
  "b95fd0a0ef8cd1278b0194509e38a0ead978fca1f4f7a832854e63920afc2e38",
  "7d0f1910f9074b32079fb054a548e1450cd60fd431475b7feff0ab51e93080b9",
  "c2eeccf12015c95f14e6522ac7d82161317560ff6c87167271013e3faf9a579b",
  "127443befe259a829ee677e8587462864f290804ef2e0f0dc3808998637a381f",
  "b2cfe13bdf0d9ea6c3ac4b6b83d70060725dd68603bcc9a91ab8bfb08a6cf8a6",
  "8230ff9c95d36fd4364171a1086cdcfd6d50d96b020baee35b4bfa9046974e53",
  "b9c1199cc4315cf58e11df01839a5f39cefd7cd2acb250731881a84ee2280c38",
  "155df18d3a3e75b3e4e8a7c6854107007b23f0bc8df381855a0c17f5716b37a8",
  "81997ef6df2cbd6eb2208e4387c3bc165d781e09954f06e4889bffc8d1c73ded",
  "d633af87589c40f17cb6d9eb5888038882096d7a1a0b4b06c064ec5967ea4e42",
  "8ae8d38171849851801e358bc282c66d1f2e77c27ab3750f2d8108f913eed0bf",
  "2c5570e669fe75b4c93e4cb4b3b3a4c4be12c96d92e93980fd0db314e7a8c532",
  "f39e86369fa0547c67cb7e9cecc600a067518dff133cbd3229feff7d0c3926c8",
  "d226ac0b3ab0f0f4b9d4e51d9a82e3124be22250d9ace8123dd96cde0d435fe1",
  "ad4383b3bd0ebab4104af0ea22c025665851bbd65974fbd14fe27141ecb30fcc",
  "54d164b9259b434953714ade425d57f3016e1142710ef4502f9373e048477b04",
  "7d3df6c64b39f234b01a39a5be9199a03e18ee161c9725f6a240fb17f438ad1c",
  "b9eb248bc5a8f1f4f4c3f90d6021a3c002b9dc51a527d7fc77bf100f52182a29",
  "9124d6bf4875b2d9d94da748ee1826c5d8bedd5623e3a4783c316740f83045d6",
  "c5314f51a9dea1580ba2a46872aa8fa72b66936b67c074ca98dacc23b1b28869",
  "d70b5c58b3f627eae77978660e281c38c49b884ec756682418e86cbfe187409a",
  "1fe7d6adde47da6d6383186cd8fe95233018513402116dc4f387d2a001d9512c",
  "fb241b8e64b9b6f72223655be4bab186e69063214108a0704cca1bd5a9552ad2",
  "05b4f04d9a98e5c618b23859b59c6f88c51b3ca1fb5db2a7eafc6b7c660d9474",
  "f5a4d0f417b31e18bc7e3dfcabef611c6f7f277424ae65c73deb42b854b9d6c4",
  "53d50dd0006b74c7ac5b9e43b235e24114606261052cf140aeab888a799d2c82",
  "4f3ad87dc13634d854c26a8affd5520adbae7e2e9eaff99b8c90b7b46c457257",
  "7eae494f3e706a4c0b2310fa835d53247f26f54a5494b5ef2677513135e1bd19",
  "f5bb90e05404f2c0be066f50fb58556afa290678191aa0dd623011ddf0145a35",
  "6f456ec35f895ffb7c7d54f68cf00c86eb5a35bc845dbf7b574d565d9399758d",
  "5f4722aa30938b870864500fdf3333fc50d172e2772ee8f5fbdfa98e97397f0f",
  "a91a47008c7ca40271cbab5736865f99c65bd54aabebc269bb64f043ba1c912c",
  "0c18af414df2d3acb5f92f3fe02ebf1cb207d716d4d2c74e768653f4928dc8a1",
  "04132e254ea6385efa91023ac15a0ea22f8f8f9883d5dfef8d7bb37a1be2a121",
  "bcf50cb52f8f70c6afbd51985cdda223f376a76f2dddb77e1941cebe09360636",
  "197f05c6065f7897626b508a523edebe9cdfbdcf2d085c52502b4a9966e9e1ab",
  "2deb084f89a9668b9715803d5e07c159b1b907b9c74df3f067039f2f97bb0604",
  "7613d3f14c76632c76dca2dca8db1cb0e61be8a8037f71e0101dbb1deea1bdd9",
  "a8fc6a931b500457b8641ee1141d4886b891a6a10185d03b6fa0224c6c0c7501",
  "1dbd1fc3fd74973eaa36ba36b0c73dc1f4b2040dc33fc711e485b244da1c1089",
  "69d25ad4ceae019111c489c3edc3860b6623f0c68ae298e3001d63d0e51fbebd",
  "22d1607d270101483f85cca0c3791770079127a45575ace8c33b81366a728e7f",
  "1396da8fc3b5c601f6208d5b11ad014f7d0aa21bc786174f8ec760e815427b06",
  "befb32ab84adcc9f4c0193eccca67425e1915ebe51be9dcdc1756d7ad96eff85",
  "f573d5f7b026c1f65405cac43cda4aea1afb636d272a4addb769014091d0a8d1",
  "6ac0920ba09a23c3b8e4818ef4b1f1616abe22a6f7788d36155c319d90be1fb4",
  "1708205e63046c68d0db1c32acbf1ad6bfac7c27c72c04021b2559e1577cb6e8",
  "a438a216c1467f37ff80de0eb2c308b2df7dd146f4d4cc93b9f9a837f9f1f3c6",
  "fd9ad87437d4423ed4bbd356b88dcba00a27327f774c7b428b96013693c83bb3",
  "29ef8a15a7578926438151ed2962d0821f27908f4de2509f545b7970b5cbecbd",
  "2738bff4e29148a9a5a20ebbfce57b1af0d019fdb8173753f5fd9411446fbb4d",
  "52dcc4cfed0884a3c0bff0ff3f62ec063cb9bbc5d0172f1aebb0417eddf04829",
  "a503322a5144eec9b3828cf75a5153db6186583a87bee6019ba9bb0d38839228",
  "46fa411bbbe2954946b254b0f198d8b7322984c188cc8ee9cac02ef58b141e98",
  "5edcadd16eaa100407b6382d48007e16a5de9b672f33609dfea62c9d8dcf3b0f",
  "7de18e8832223e586aca6944d779f4ce6ef493b15c39879c6574a9d4d61a7b99",
  "e3c34ec26df5f73d1fd5214e4888cffb2742af53119e1f2e532348f472ad384b",
  "915784987b3b4897e8b0c4ae81c7f2dc1c4972d430fcd6ecce8d8aff0d1de45e",
  "44b6b7fff4be05773cb89891b3c24a1047e9497a481b7a1d6a8ed0f94f05afdf",
  "bfb04e675599f52503736788b48d3afe05075931a6415c8908cb42d25e2b9ce6",
  "6dc47866dc72f837acf786a7214ddae438e385b1bc466cc67f908c62c57fcc37",
  "df03c59368307d69b8eee9d6eee1bfcd04ed51a359bfbb758a6429926db8c99e",
  "43f9739d1b87b43851cccefe018aab63b1fb62ba0ca6fba83911d571b29c6c01",
  "3fd1b44c534b9024c109ea86f2007c62daa0a2e058f1e6e0e0a5600b4bc590bd",
  "e85de90988f9ae9d0371353fc4cc323b0adc68428024c214c1fc5a8822b44cdb",
  "6e1c97ceba787042e97db28d390dba12fbe89ae42e849387d9bc8d8e27dac3b4",
  "bf1f3285ad013052a09c219d385bef4e025424618dc5af8a3855b9b9acf29dc3",
  "b7614dd9a5432500cdb6276bb5d028bf3525f712ec492974fbde0dff9393d75b",
  "f6e100a0a84a0610839bad4d4952791455fabe5de11992822beab6ad21a4cc94",
  "fa322adf56f3cec7966804bfec7cbf243a344b5c9ab5983a81adedb02c089ebb",
  "cee75d38512e31ba49e0f9aaf9f12d26195b37fbd6d845c3025ea143553da5e8",
  "cf7614e13f16b3b7194a4257f3a9b471041a1cd7790e72cdd11b8014d41e371d",
  "235eb34fa1ef06683de443ee46194e991195c2219216e454d3ee2001ad929a92",
  "bb0cb2e55e212b5e5ac57dd79442710d8434e6454f41d340f4861a9f63309677",
  "37fabf2c346ce72d533b137014501af5fb7649b6636e330d88af2d9246046a82",
  "17d60b73196b8c997c31d2e43bc700e5950803a4cc050a4638bc1f9a8978bf35",
  "20bfae1d2e0380a7dce07fac7c9fc830e6e914432382104e16bb21b590f31b7f",
  "57c4117a48f635b6920dad1933673ea81b900146b585a85d49dcaefa2f6b8687",
  "5de589f480962801137ce176e2d4078c917a5cdcae31d3d5493da3f5522e535b",
  "459c50f468b5204bca139f67680ff0b3df4ec3ae8ae298ab17d513bf94db4159",
  "b4f392e0d54b782d9ae5460b56542bc9384eb65c09e83906e0f1b604faaad8cb",
  "c1141e7e6c2a69dcbb36e596d2b0cef8e2f85b782fb6e9b7c4806efbd2334c8c",
  "ce609d44aa2364b7dd7b2a9458fadeba7c372eef3a3efff589823adedc4b7b4a",
  "5c5d2e495208ec2de6497e9ca6293fa24240b07d416f0acc2a3638c962a9a3cd",
  "1b1ad9dfd18ec1738ef11e6916e73ad8c4adca3c63c34f1debb5f541c0bc52e3",
  "3cbec2de5298a0b5feb676605caf0124b7e0354063cc98d5b68b6d92e91adc3c",
  "a0e0a03d855f23a6ae17206f5a889a49dba5a29d232247ecfffadedad2a11893",
  "15161c28a13178a95eaf750672cf3e53e4284bbf27f3a7f5123562d8927182c2",
  "608b393a779eea4431fee93a1a6d073c67d8d63de6d4281239fedebf56ba07b1",
  "c475875fddb5ef01e01d2c84ee21f6a7fd77c188cefc685bcf4a5887d86cb64d",
  "7fba2196fd3ea1e2cbcc4cf3cbcba0635a29cb2c8e839cb7b12f35adaede21b5",
  "e5b051fda4d9884d91bd25b5f6f49e3bda69261bbef4706b6679afddcd34675d",
  "c43f623cb8acdd1db876559db8afe6630bd0622af74ee3b5173a9d2b4a11ef6a",
  "bf8f55208ccabc7d58fd003bc59899b282e0982ce8a4cf194d65b66218fa106c",
  "2996124c9a0421e308fec043ba7ca0f914a130e860a3855a8f34db813b4e273b",
  "06d66137cd36a2e52697b7783d730e64e632ebc6b20e593a1778ebe73b9c918e",
  "ce07171193e7cefa6621816397f0fd3a331f6cf1e9e1da7e9445c59cf569a139",
  "88b946731a795e9b18cedb0fab7bb05bca10eeb1e5ba6ba3135d85eee4899b51",
  "45123dd6ddea0bca39a9e17377cb1f3fb744bbb53e3b29313910ed3edef18fd0",
  "632880c4d7698c6cb0db5097f5d9d2be8e19c102fb713ca82cb0b821aba1d926",
  "34a4676c6963cf90c55ba1e1ffd4a09c183e3d2449303784b31505767346cbe4",
  "b78f9c2c2090885f8e294e675a6552d87d77df18e7a2f732f18cc568971980d5",
  "9143a0767f395dd346c302da75bea0dc84101542fcbfdf55540a067dacd56368",
  "567295df4e1cb68029f4f4eb413925d8ee9183c2661ec95549879fbfd9e092e3",
  "772f5e81ae642460b3eb3f8514e452c800edf66b806f17c7f4564677abbd8041",
  "b3c06c6b297f148cc18dd6d5a7348d6f1472c09a85218ab49e2681fe7a0b31d5",
  "efb631a957e857a4631e5c0146a5478a8fa980ac92f0215d4a86d6b821998d27",
  "335cae63ad7aaae80261679596d389a8af67205ae3a439e0bc4bd8fb617331de",
  "b7835d8947b895dd1e7e9ffef7afdf6ea4d1250ac6c00066ae1ad10d7a49a978",
  "ac85d12f9f5b4ff6fe513adf6e8e5482f128ef99ffb30940a9a6c75ef6565a86",
  "278da63a33b71f9cabfe5029a9a154fe382dd7d0f65177a4ed82dae64ca66e04",
  "db6a1caf301088f0087d046b49e61400f3a44b35d5c0c6b4a61ce7fe77db61cc",
  "de4938a628f484ba2319200f16594d2fe1eafd0c84cfae19c5ee343ba37618d0",
  "dbab92df0e8880e6b006564825998fd0ee986d97e6c39c9634ac95fd52c9a5bc",
  "7c82533610d5053838b723e6f88aad9d27c6c50c2803da3b0698fe581b6d12a9",
  "37201b3df51384382cc6f21758acb94291dd8a2c7808214393dbe37d47cf3f3c",
  "10b9a824d564a21df9ba660760f0ada0ed769a362914f49d71ab9262c2ad4415",
  "d8bd141d888195d0d7bb03c2caddb876c154413698e9b596834c0f31a2622efc",
  "9a4c8375fd364111653c5a892140d3ee8ab90324fbb28e82844725881b79ce8d",
  "de04c8daca20c8ed2ff73f40f784472eba60f2d414e7ae16300264b6db6b1093",
  "286f607081654736db1fc873651e999e7b885321b57d062e936de9d750fc7d8d",
  "8d925856e0cac20fdbd082c9aaee2be5a66854d7ffc937511baa192e4d4f0623",
  "05e4667e88de72d0ec4481c0db45a39a025edd1a94cbd154f9d53ffc74681603",
  "ebc8b2111cfebd72b700429e95caf2f09ffec19ce8e0f873d6b67825cf6d8969",
  "d6f4c4b9169443aa8b35ea8590146c23cfe4987dfabce5a04e92777ed276743e",
  "3d30a1eaae7958779d1e7244097498c47105b0c9b0f8a2b2aa73280801647652",
  "fc047c803c9472c0f1e779fc8af5e53f8ba0fb1503a13f6cc77cebbc3a89b631",
  "d1ef994f0f3d6d600aff23795f33cbe3f0a896bb35274aff529730d9b9948b52",
];

export const calcHash = (token: string): string => {
  const shaNormal = new jsSHA("SHA-256", "TEXT");
  shaNormal.update(token);
  return shaNormal.getHash("HEX");
};
